import Tile from "../Tile";
import MUIGreyColor from "@mui/material/colors/grey";
import Vendor from "../../Utility/Crud/Vendor";

export default class TileVendor extends Tile {
  /**
   * @returns {string} The Vendor name.
   */
  getTitle() {
    return this.props.vendor
      ? Vendor.getDisplayName(this.props.vendor)
      : "None";
  }

  /**
   * @returns {string} The string to be used by the avatar abbreviation
   * formatter.
   */
  getAvatarString() {
    return this.props.vendor ? Vendor.getDisplayName(this.props.vendor) : null;
  }

  /**
   * @returns {string} The color of the avatar.
   */
  getAvatarColor() {
    return this.props.vendor ? Vendor.getColor() : MUIGreyColor[400];
  }

  /**
   * Renders an icon to represent the avatar if no string is provided.
   */
  renderAvatarIcon() {
    return Vendor.getIcon();
  }
}
